import uPlot from "uplot";

type ScaleStops = { lowerBound: number; color: string }[];

export const getDiscreteColor = ({
  u,
  scaleStops,
  tradeUnit,
}: {
  u: uPlot;
  scaleStops: ScaleStops;
  tradeUnit: string;
}) => {
  const ctx = u.ctx;

  const scale = u.scales[tradeUnit];
  let minStopIdx: number | null = null;
  let maxStopIdx: number | null = null;

  for (let i = 0; i < scaleStops.length; i++) {
    const stopVal = scaleStops[i].lowerBound;

    if (stopVal <= (scale.min ?? 0) || minStopIdx == null) minStopIdx = i;
    maxStopIdx = i;
    if (stopVal >= (scale.max ?? 0)) break;
  }

  if (minStopIdx === maxStopIdx) return scaleStops[minStopIdx as number].color;

  let minStopVal: number = scaleStops[minStopIdx as number].lowerBound;
  let maxStopVal: number = scaleStops[maxStopIdx as number].lowerBound;

  if (minStopVal === -Infinity) minStopVal = scale.min ?? 0;
  if (maxStopVal === Infinity) maxStopVal = scale.max ?? 0;

  const minStopPos = u.valToPos(minStopVal, tradeUnit, true);
  const maxStopPos = u.valToPos(maxStopVal, tradeUnit, true);

  const range = minStopPos - maxStopPos;

  const x0 = 0;
  const x1 = 0;
  const y0 = minStopPos;
  const y1 = maxStopPos;

  const grd = ctx.createLinearGradient(x0, y0, x1, y1);

  let prevColor = "";

  for (let i = minStopIdx ?? 0; i <= (maxStopIdx ?? 0); i++) {
    const s = scaleStops[i];

    const stopPos =
      i === minStopIdx
        ? minStopPos
        : i === maxStopIdx
        ? maxStopPos
        : u.valToPos(s.lowerBound, tradeUnit, true);
    const pct = (minStopPos - stopPos) / range;

    if (i > (minStopIdx ?? 0)) grd.addColorStop(pct, prevColor);

    grd.addColorStop(pct, (prevColor = s.color));
  }

  return grd;
};
